import React, { useContext } from 'react';
import {
    Box,
    Divider,
    Grid,
    Typography,
    useTheme,
    useMediaQuery,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../../sporttia/AppContext';
import { SttButtonAccept } from '../../../sporttia/buttons/SttButtonAccept';
import { formatPriceByLocale, redirectLogin } from '../../../lib/utils';

export default function RateList({ rates, onSelected, inIscTime }: any) {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const smUp = useMediaQuery(theme.breakpoints.up('sm'));

    function SignupButton({ rate }: any) {
        return (
            <SttButtonAccept
                style={{ width: 270 }}
                fullWidth={!!smUp}
                caption={
                    rate.signupOnline
                        ? t('activity.signUpNow')
                        : t('general.moreInfo')
                }
                onClick={() =>
                    rate.signupOnline && !cxt.logged
                        ? redirectLogin(navigate, location)
                        : onSelected(rate)
                }
                disabled={!inIscTime}
            />
        );
    }

    if (!rates || rates.length === 0) {
        return <Typography variant="body1">{t('activity.noRates')}</Typography>;
    }

    return (
        <div>
            {rates.map((rate: any, i: any) => (
                <React.Fragment key={i}>
                    {i > 0 && (
                        <Box my={1}>
                            <Divider />
                        </Box>
                    )}
                    <Box p={1}>
                        <Grid container spacing={3}>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography>{rate.name}</Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Box
                                    display="flex"
                                    justifyContent={
                                        smUp ? 'flex-end' : 'flex-start'
                                    }
                                >
                                    <Typography variant="body1">
                                        <span>
                                            {t('activity.signedCount')}:
                                        </span>
                                        <span>&nbsp;</span>
                                        <b>
                                            {rate.maxStudents
                                                ? `${rate.numStudents} / ${rate.maxStudents}`
                                                : rate.numStudents}
                                        </b>
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <Box>
                                    <span>
                                        {`${t('activity.enrollment')}:`}&nbsp;
                                    </span>
                                    {rate.enrollment ? (
                                        <b>
                                            {formatPriceByLocale(
                                                rate?.enrollment,
                                                rate?.enrollmentShape?.currency,
                                                rate?.enrollmentShape?.locale,
                                            )}
                                        </b>
                                    ) : (
                                        <span>{t('payment.free')}</span>
                                    )}
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <Box>
                                    <span>{`${t('activity.fee')}:`}&nbsp;</span>
                                    {rate.fee ? (
                                        <b>{`${formatPriceByLocale(
                                            rate?.fee,
                                            rate?.feeShape?.currency,
                                            rate?.feeShape?.locale,
                                        )} / ${rate.periodLang}`}</b>
                                    ) : (
                                        <span>{t('activity.noFees')}</span>
                                    )}
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                {smUp ? (
                                    <Box
                                        display="flex"
                                        justifyContent="flex-end"
                                    >
                                        <SignupButton rate={rate} />
                                    </Box>
                                ) : (
                                    <SignupButton rate={rate} />
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </React.Fragment>
            ))}
        </div>
    );
}
